import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
  DEFAULT_LOCALE,
  normalizeLocale,
  SUPPORTED_LOCALE_CODES,
} from './config/locales';
import enUS from './locales/en-US.json';
import enGB from './locales/en-GB.json';
import frFR from './locales/fr-FR.json';
import esES from './locales/es-ES.json';
import deDE from './locales/de-DE.json';
import itIT from './locales/it-IT.json';
import ptPT from './locales/pt-PT.json';
import nlNL from './locales/nl-NL.json';
import esCO from './locales/es-CO.json';
import esAR from './locales/es-AR.json';
import esMX from './locales/es-MX.json';
import enAU from './locales/en-AU.json';
import enCA from './locales/en-CA.json';

function readShopLocale() {
  try {
    const saved = localStorage.getItem('shop-locale');
    if (saved && String(saved).trim()) return normalizeLocale(saved);
  } catch {
    // ignore
  }
  return DEFAULT_LOCALE;
}

i18n.use(initReactI18next).init({
  resources: {
    'en-US': { translation: enUS },
    'en-GB': { translation: enGB },
    'fr-FR': { translation: frFR },
    'es-ES': { translation: esES },
    'de-DE': { translation: deDE },
    'it-IT': { translation: itIT },
    'pt-PT': { translation: ptPT },
    'nl-NL': { translation: nlNL },
    'es-CO': { translation: esCO },
    'es-AR': { translation: esAR },
    'es-MX': { translation: esMX },
    'en-AU': { translation: enAU },
    'en-CA': { translation: enCA },
  },
  lng: readShopLocale(),
  fallbackLng: DEFAULT_LOCALE,
  supportedLngs: SUPPORTED_LOCALE_CODES,
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export default i18n;

